import { Icon } from "@iconify/react"
import { Button, Card, Flex, Grid, Image, Input, message, Pagination, Table } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { bannerService } from "../../services/banner.service";
import useTitleStore from "../../store/titleStore";
import { useTableHeight } from "../../hooks/useTableHeight";
import useDebounce from "../../hooks/useDebounce";
import TableAction from "../../components/TableAction";
import { API_BASE_URL } from "../../config/api.config";
import UpdatedByCell from "../../components/UpdatedByCell";
import { breadcrumbStore } from "../../store/breadcrumbStore";

export default function BannerIndex(){

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const { toggle, page } = breadcrumbStore();
  const queryClient = useQueryClient();
  const tableHeight = useTableHeight();
  
  const [messageApi, contextHolder] = message.useMessage();
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  const { data: informationData , isLoading, isRefetching } = useQuery({
    queryKey: ['faqs', dataParams],
    queryFn: () => bannerService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })

  const { mutate: handleDelete, isPending: deleteLoading } = useMutation({
    mutationFn: (id) => bannerService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('faqs');
      messageApi.success('Data berhasil dihapus');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  useEffect(() => {
    setTitle("Banner");
    toggle(page.BANNER_INDEX)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      filter: [
        {
          field: 'title',
          operator: 'like',
          value: debouncedKeyword
        }
      ]
    }));
  }, [debouncedKeyword]);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      render: (text, record, index) =>  index + 1,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Gambar',
      dataIndex: 'image',
      width: 70,
      fixed: breakpoint.md && 'left',
      render: val => <Image width={60} src={`${API_BASE_URL}/${val}`} />
    },
    {
      title: 'Judul',
      dataIndex: 'title',
      width: 210,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Tanggal Update',
      width: 210,
      render: val => <UpdatedByCell value={val} />,
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 110,
      fixed: 'right',
      render: record => (
        <TableAction
          onClickEdit={() => navigate('/banner/detail/'+record.id)}
          handleDelete={() => handleDelete(record.id)}
          deleteLoading={deleteLoading}
        />
      )
    },
  ]

  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      {contextHolder}
      <Flex justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} gap={20} >
        <Input 
          style={{ width: 320 }} 
          prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
          placeholder="cari..."
          onChange={e => setKeyword(e.target.value)}
          value={keyword}
        />
        <Button 
          variant="solid" 
          color="primary"  
          icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
          onClick={() => navigate('/banner/create')}
          style={{ marginLeft: !breakpoint.md && 'auto', minWidth: 38 }}
        >
          {breakpoint.md && 'Tambah Banner'}
        </Button>
      </Flex>
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={'id'}
        scroll={{ y: tableHeight }}
        dataSource={informationData?.data}
      />
      <Pagination
        style={{ marginInline: 24, marginTop: 16 }}
        total={informationData?.pagination?.total}
        showSizeChanger={{
          showSearch: false
        }}
        pageSizeOptions={['10', '20', '50']}
        current={informationData?.pagination?.page}
        pageSize={dataParams.limit}
        align="end"
        onChange={handleChangePage}
        
      />
    </Card>
  )
}